export const assetUrl = (url: string): string => {
  if (process.env.NODE_ENV === 'development') {
    return `/app/assets${url}`;
  }
  // TODO: this is hardcoded url and it will not refresh image if you upload a new one. Image is cached by cloudfront. We should use the asset_url filter somehow.
  return `${process.env.PUBLIC_URL}/assets${url}?updated=1693304109`;
};
